import type { FC, useEffect } from "react"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { styled, useTheme } from "@mui/material/styles"
import {
  Box,
  Step,
  Stepper,
  IconButton,
  Button,
  Tooltip,
  Typography,
  Stack,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  tooltipClasses,
} from "../../../components/mui.components"
import { Warning, Info } from "@mui/icons-material"
import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { ReactSVG } from "react-svg"

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"

import CloseSvg from "../../assets/modeltools/RedXMark.svg"
import ResetSvg from "../../assets/bottomToolBar/stage/reset.svg"

import { resegmentationModule } from "@/gluelayer/core/modules/resegmentation/resegmentationModule"
import { caseManagement } from "@/gluelayer"
import { setIsOpenModelCheck } from "@/UDTreat/udTreatSlice"
import { set } from "react-hook-form"
import { TooltipProps } from "@mui/material/Tooltip"

interface Type {
  ClickAddTooth?: () => void
  ClickDelTooth?: () => void
  ClickPaint?: () => void
  ClickDrag?: () => void
  ClickUndo?: () => void
  ClickReset?: () => void
  ClickIdel?: () => void
  ClickClose?: (e) => void
  DoShowClose?: boolean
}

const ResegmentTools: FC<Type> = ({
  ClickAddTooth,
  ClickDelTooth,
  ClickPaint,
  ClickDrag,
  ClickUndo,
  ClickReset,
  ClickIdel,
  ClickClose,
  DoShowClose,
}) => {
  const dispatch = useAppDispatch()
  const theme = useTheme()

  const { t } = useTranslation("common")

  const [selectedItem, setSelectedItem] = useState<string | null>("")
  const [lastSelectedItem, setLastSelectedItem] = useState<string | null>("")
  const [deleteStageDlg, setDeleteStageDlg] = useState(false)
  const { startAutoModelCheck } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )

  const [deleteOKCallback, setDeleteOKCallback] = useState<() => void>()

  const buttonNames = [
    "Adjust Color",
    "Drag Line",
    "Add Tooth",
    "Exclude Tooth",
    "Undo",
    "Reset",
  ]

  const buttonId = ["Paint", "Drag", "Add", "Del", "Undo", "Reset"]

  const [floatButtonVisible, setFloatButtonVisible] = useState<boolean>(false)
  const [floatButtonPos, setFloatButtonPos] = useState<{
    x: number
    y: number
  }>({ x: 420, y: 160 })

  const onResegmentationToIdleCB = () => {
    setSelectedItem("")
  }

  React.useEffect(() => {
    resegmentationModule.SetResegmentationToIdleCB = onResegmentationToIdleCB
  }, [])

  React.useEffect(() => {
    if (ClickIdel && lastSelectedItem != "") ClickIdel()

    switch (selectedItem) {
      case "Add":
        if (ClickAddTooth) ClickAddTooth()
        break
      case "Del":
        if (ClickDelTooth) ClickDelTooth()
        break
      case "Paint":
        if (ClickPaint) ClickPaint()
        break
      case "Drag":
        if (ClickDrag) ClickDrag()
        break
      //  case "Undo":
      //  if(ClickUndo)ClickUndo()
      //    break
      //  case "Reset":
      //  if(ClickReset)ClickReset()
      //    break

      default:
    }

    setLastSelectedItem(selectedItem)
  }, [selectedItem])

  React.useEffect(() => {
    resegmentationModule.Set2DButtonsVisiblityJsCallBack((isShow: boolean) => {
      console.log("Set2DButtonsVisiblityJsCallBack isShow:", isShow)
      setFloatButtonVisible(isShow)
    })
    resegmentationModule.SetUpdate2DButtonsPosJsCallBack(
      (x: number, y: number) => {
        console.log("SetUpdate2DButtonsPosJsCallBack x:", x, " y:", y)
        setFloatButtonPos({ x: x, y: y + 20 })
      },
    )
  }, [selectedItem])
  const GuideTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#3a3f43",
      color: "#ffffff",
      fontSize: "12px",
      borderRadius: "0px",
      padding: "8px 12px",
      boxShadow: "none",
      border: "1px solid #ffffff",
      maxWidth: "none",
      whiteSpace: "nowrap",
      textAlign: "center",
    },
    [`& .${tooltipClasses.arrow}`]: {
      display: "none", // 隐藏箭头
    },
  }))

  const TooltipContent = ({ title, desc }) => (
    <Stack direction={"row"} alignItems="center">
      <Typography sx={{ fontWeight: 600 }}>{title}</Typography>
      <Typography sx={{ fontWeight: 400 }}>{desc}</Typography>
    </Stack>
  )

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-end",
          position: "absolute",
          top: "250px",
          right: "1%",
          width: "130px",
          height: "500px",
          borderRadius: 2,
          flexDirection: "column",

          //bgcolor: theme.transBkColor.light
        }}
      >
        <Box
          sx={{
            display: "flex",
            right: "2%",
            width: "250px",
            height: "70px",
            borderRadius: 2,
            flexDirection: "row",
            alignItems: "center",
            //bgcolor: theme.transBkColor.light
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-end",
              width: "100%",
              height: "70px",
              borderRadius: 2,
              flexDirection: "column",
              marginRight: "20px",

              //bgcolor: theme.transBkColor.light
            }}
          >
            <Typography variant="h5" color="#FFFFFF">
              Check
            </Typography>
            <Typography variant="h5" color="#FFFFFF">
              Segmentation
            </Typography>
          </Box>

          {DoShowClose && (
            <Box
              sx={{
                display: "flex",
                alignItems: "column",
                padding: "0px 0px",
                width: "35px",
                height: "50px",
              }}
            >
              <IconButton
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "35px",
                  height: "35px",
                  borderRadius: 100,
                  backgroundColor: "#FF632B",
                  "&:hover": { background: "#FF632B" },
                }}
                onClick={ClickClose}
              >
                <img
                  src={CloseSvg}
                  style={{ height: "18px", width: "18px" }}
                ></img>
              </IconButton>
            </Box>
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginTop: "15px",
            width: "65px",
            height: "261px",
            // borderRadius: 2,
            flexDirection: "column",
            marginRight: "5px",
            // gap: "1px",
            // paddingTop: "15px",
            // backgroundColor: theme.transBkColor.light,
          }}
        >
          <GuideTooltip
            placement="left"
            title={
              <TooltipContent
                title="Adjust Color:"
                desc={`\u00A0Use the painting tool to fix coloring inaccuracies`}
              />
            }
          >
            <Button
              sx={{
                height: "65px",
                width: "65px",
                textTransform: "none",
                // flexWrap: "wrap",
                border: "none",
                padding: "0px 0px",
                borderRadius: "0px",
                background: selectedItem === "Paint" ? "#00ADEF" : "#f9f9f9",
                "&:hover": {
                  background: selectedItem === "Paint" ? "#00ADEF" : "#f9f9f9",
                },
                borderBottom: "1px solid",
                borderColor: "rgba(59 / 255, 66 / 255,  71 / 255 )",
                justifyContent: "center",
              }}
              onClick={(e) => {
                if (buttonId[0] != lastSelectedItem) {
                  setSelectedItem(buttonId[0])
                } else {
                  setSelectedItem("")
                }
              }}
            >
              <Typography
                width="100%"
                textAlign="center"
                // padding="10px"
                fontSize="14px"
                fontWeight="600"
                fontFamily="Roboto"
                fontStyle="normal"
                color={selectedItem === "Paint" ? "#fff" : "#444444"}
                letterSpacing="0.1px"
              >
                Adjust Color
              </Typography>
            </Button>
          </GuideTooltip>
          <GuideTooltip
            placement="left"
            title={
              <TooltipContent
                title="Add Tooth:"
                desc={`\u00A0Paint any unidentified white tooth to add`}
              />
            }
          >
            <Button
              sx={{
                height: "65px",
                width: "65px",
                textTransform: "none",
                flexWrap: "wrap",
                padding: "0px 0px",
                borderRadius: 0,
                background: selectedItem === "Add" ? "#00ADEF" : "#f9f9f9",
                "&:hover": {
                  background: selectedItem === "Add" ? "#00ADEF" : "#f9f9f9",
                },
                borderBottom: "1px solid",
                borderColor: "rgba(59 / 255, 66 / 255,  71 / 255 )",
                // backgroundColor:
                //   selectedItem === "Add"
                //     ? theme.transBkColor.light
                //     : "rgba(0, 0, 0, 0.0)",
              }}
              onClick={(e) => {
                if (startAutoModelCheck) {
                  if ("Add" !== lastSelectedItem) {
                    setSelectedItem("Add")
                    console.log("set Add")
                  } else {
                    setSelectedItem("")
                  }
                } else {
                  if (lastSelectedItem == "Add") {
                    console.log("cancel Add selection")
                    setSelectedItem("")
                    return
                  }

                  setDeleteOKCallback(() => {
                    return () => {
                      if ("Add" !== lastSelectedItem) {
                        setSelectedItem("Add")
                        console.log("set Add")
                      } else {
                        setSelectedItem("")
                      }
                    }
                  })
                  setDeleteStageDlg(true)
                }
              }}
            >
              <Typography
                width="100%"
                textAlign="center"
                padding="10px"
                fontSize="14px"
                fontWeight="600"
                fontFamily="Roboto"
                fontStyle="normal"
                color={selectedItem === "Add" ? "#fff" : "#444444"}
                letterSpacing="0.1px"
              >
                Add Tooth
              </Typography>
            </Button>
          </GuideTooltip>
          <GuideTooltip
            placement="left"
            title={
              <TooltipContent
                title="Exclude Tooth:"
                desc={`\u00A0Remove an incorrectly identified tooth by clicking on colored area`}
              />
            }
          >
            <Button
              sx={{
                height: "65px",
                width: "65px",
                textTransform: "none",
                flexWrap: "wrap",
                border: "none",
                padding: "0px 0px",
                borderRadius: "0px",
                background: selectedItem === "Del" ? "#00ADEF" : "#f9f9f9",
                "&:hover": {
                  background: selectedItem === "Del" ? "#00ADEF" : "#f9f9f9",
                },
                borderBottom: "1px solid",
                borderColor: "rgba(59 / 255, 66 / 255,  71 / 255 )",
                // backgroundColor:
                //   selectedItem === "Del"
                //     ? theme.transBkColor.light
                //     : "rgba(0, 0, 0, 0.0)",
              }}
              onClick={(e) => {
                if (startAutoModelCheck) {
                  if ("Del" != lastSelectedItem) {
                    setSelectedItem("Del")
                    console.log("set Del")
                  } else {
                    setSelectedItem("")
                  }
                } else {
                  if (lastSelectedItem == "Del") {
                    console.log("cancel Del selection")
                    setSelectedItem("")
                    return
                  }

                  setDeleteOKCallback(() => {
                    return () => {
                      if ("Del" != lastSelectedItem) {
                        setSelectedItem("Del")
                        console.log("set Del")
                      } else {
                        setSelectedItem("")
                      }
                    }
                  })

                  setDeleteStageDlg(true)
                }
              }}
            >
              <Typography
                width="100%"
                textAlign="center"
                // padding="10px"
                fontSize="14px"
                fontWeight="600"
                fontFamily="Roboto"
                fontStyle="normal"
                color={selectedItem === "Del" ? "#fff" : "#444444"}
                letterSpacing="0.1px"
              >
                Exclude Tooth
              </Typography>
            </Button>
          </GuideTooltip>

          <Button
            sx={{
              height: "65px",
              width: "65px",
              textTransform: "none",
              flexWrap: "wrap",
              padding: "0px 0px",
              border: "none",
              borderRadius: "0px",
              background: "#f9f9f9",
              "&:hover": {
                background: "#f9f9f9",
              },
            }}
            onClick={(e) => {
              if (ClickUndo) ClickUndo()
            }}
          >
            <Typography
              fontSize="14px"
              fontWeight="600"
              fontFamily="Roboto"
              fontStyle="normal"
              color="#444444"
              letterSpacing="0.1px"
            >
              Undo
            </Typography>
          </Button>

          {/* <Button
              sx={{
                height: "20px",
                width: "52px",
                textTransform: "none",
                flexWrap: "wrap",
                border: "none",
                padding: '0px 0px',
                borderRadius: "0px",
                backgroundColor:
                  selectedItem === "Reset"
                    ? theme.transBkColor.light
                    :  "rgba(0, 0, 0, 0.0)"
              }}
          onClick={(e) => 
            {
              if('Reset'!=lastSelectedItem){
                  setSelectedItem('Reset');
              }else{
                  setSelectedItem('');
              }}}
            
            >
              <Typography fontSize= "14px" fontWeight= "600" fontFamily= "Roboto" fontStyle="normal" color="#444444" letterSpacing="0.1px">
                Reset
              </Typography>
            </Button> */}
        </Box>
      </Box>
      <Box
        sx={{
          visibility: floatButtonVisible ? "visible" : "hidden",
          position: "absolute",
          bottom: floatButtonPos.y,
          left: floatButtonPos.x,
          display: "flex",
          alignItems: "center",
          gap: 4,
          zIndex: 999,
          translate: "-50%",
        }}
      >
        <Button
          onClick={() => {
            resegmentationModule.ConfirmAddTooth()
          }}
          sx={{
            width: 120,
            height: 50,
            borderRadius: "8px",
            backgroundColor: "rgba(230, 230, 230, 1)",
            color: "#000",
            boxShadow: "0 4px 8px rgba(0,0,0,0.20)",
            fontSize: 20,
            fontWeight: 500,
            lineHeight: 1.2,
            textTransform: "none",
            "&:hover": {
              backgroundColor: "rgba(180, 180, 180, 1)",
            },
          }}
        >
          Add tooth
        </Button>
      </Box>
      <Dialog open={deleteStageDlg}>
        <DialogTitle id="alert-dialog-title">{"uDesign Cloud"}</DialogTitle>
        <DialogContent>{`To add or exclude a tooth on the model, the current treatment plan will be deleted, proceed?`}</DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              // if (planList.length > 1) caseManagement.delTx(2)  //这里不删方案是为了防止颜色出现重叠异常
              // caseManagement.delTx(1)

              if (deleteOKCallback) deleteOKCallback()

              setDeleteOKCallback(undefined)
              setDeleteStageDlg(false) // 关闭对话框
            }}
            autoFocus
            sx={{ textTransform: "samelabel" }}
            size="medium"
            color="primary"
            variant="contained"
          >
            Yes
          </Button>
          <Button
            onClick={() => setDeleteStageDlg(false)}
            autoFocus
            sx={{ textTransform: "samelabel" }}
            size="medium"
            color="primary"
            variant="contained"
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
export default ResegmentTools
